/**
 * Registered-vendor annexure fill uses designer (onboarding2) questionnaire UI for these API codes.
 */
export const DESIGNER_ANNEXURE_API_CODES = new Set([
  '4',
  '5',
  '6',
  '9',
  '11',
  '12',
  '13',
  '15A',
  '15B',
]);

export function annexureCodeUsesDesignerUi(code: string | null | undefined): boolean {
  const c = String(code ?? '').trim();
  return DESIGNER_ANNEXURE_API_CODES.has(c);
}

/** Onboarding2 static definition keys in `onboarding2AnnexureFormConfig.ts` */
export function ob2AnnexureIdForApiCode(code: string | null | undefined): string | undefined {
  const c = String(code ?? '').trim();
  switch (c) {
    case '4':
      return 'a4';
    case '5':
      return 'a5';
    case '6':
      return 'a6';
    case '9':
      return 'a9';
    case '11':
      return 'a11';
    case '12':
      return 'a12';
    case '13':
      return 'a13';
    case '15A':
      return 'a15a';
    case '15B':
      return 'a15b';
    default:
      return undefined;
  }
}

/** API annexure code for a static designer definition id (`a12` → `12`, `a15a` → `15A`). */
export function ob2ApiCodeFromDefinitionId(annexureId: string | null | undefined): string {
  const id = String(annexureId ?? '').trim().toLowerCase();
  switch (id) {
    case 'a4':
      return '4';
    case 'a5':
      return '5';
    case 'a6':
      return '6';
    case 'a9':
      return '9';
    case 'a11':
      return '11';
    case 'a12':
      return '12';
    case 'a13':
      return '13';
    case 'a15a':
      return '15A';
    case 'a15b':
      return '15B';
    default:
      return '';
  }
}
